window.$ = window.jQuery = require('jquery');

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

window.gsap           = gsap;
window.ScrollTrigger  = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;

$(function () {

    let speed = 1;
    /*  SCENE 1 */
    let scene1 = gsap.timeline();
    ScrollTrigger.create({
        animation: scene1,
        trigger: ".scrollElement",
        start: "top top",
        end: "1500 top",
        scrub: 3,
    });

    scene1.fromTo(".monr1", { y: 0,  opacity:1 },{transform : 'translateY(-41vh)',  opacity:0}, 0)
    scene1.fromTo(".left-slogan-area", { y: 0 },{transform : 'translateY(-95vh)',opacity:0}, 0)
    scene1.fromTo(".monl2", { y: 0 },{transform : 'translateY(-83.76vh)', opacity:0}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "0 top",
        end: "100",
        scrub: 1,
        onEnter:function () {
            gsap.set(".scrolldown", {opacity:1,duration:0.3  })
            gsap.to(".scrolldown", {opacity:0,duration:0.3  })
        },
        onEnterBack:function () {
            gsap.to(".scrolldown", {opacity:1,duration:0.3  })
        }
    });



    let scene2 = gsap.timeline();
    ScrollTrigger.create({
        animation: scene2,
        trigger: ".scrollElement",
        start: "top top",
        end: "1800 top",
        scrub: 3,

    });
    scene2.fromTo(".ml01", {transform : 'translate(0,0)',autoAlpha:1 },{transform : 'translate(0,-188vh)'}, 0)

    scene2.fromTo(".ml02", { y: 0 },{transform : 'translateY(-195vh)',  }, 0)
    scene2.fromTo(".ml03", { y: 120,x:0 },{transform : 'translateY(-209vh)',x:-10 * speed }, 0)
    scene2.fromTo(".ml04", { y: 120 },{transform : 'translateY(-210vh)',  }, 0)
    scene2.fromTo(".cloudy-foogy2", { y: 0,x:0 },{transform : 'translate(-50vw,-210vh)'}, 0)

    let alphao = gsap.timeline();
    ScrollTrigger.create({
        animation: alphao,
        trigger: ".scrollElement",
        start: "1800 top",
        end: "2000 top",
        scrub: 3,
    });
    alphao.fromTo(".ml01", {autoAlpha:1 },{autoAlpha:0}, 0)
    alphao.fromTo(".ml02", {autoAlpha:1 },{autoAlpha:0}, 0)
    alphao.fromTo(".ml03", {autoAlpha:1 },{autoAlpha:0}, 0)
    alphao.fromTo(".ml04", {autoAlpha:1 },{autoAlpha:0}, 0)

    let flycb = gsap.timeline();
    ScrollTrigger.create({
        animation: flycb,
        trigger: ".scrollElement",
        start: "0 top",
        end: "1000 top",
        scrub: 1,
    });
    flycb.fromTo(".flycb img", {autoAlpha:1 },{autoAlpha:0}, 0)


    let scene3 = gsap.timeline();
    ScrollTrigger.create({
        animation: scene3,
        trigger: ".scrollElement",
        start: "500 top",
        end: "1500 top",
        scrub: 3,
    });
    scene3.to(".ml01", {x:-100}, 0)
    scene3.to(".ml02", {x:100}, 0)
    scene2.fromTo(".cloudy-foogy3", { transform : 'translate3d(0,0,0)' },{transform : 'translate3d(50vw,-20vw,0)',opacity:0}, 0)


    let resontime1 = gsap.timeline();
    ScrollTrigger.create({
        animation: resontime1,
        trigger: ".scrollElement",
        start: "850 top",
        end: "950 top",
        scrub: 3,
    });
    resontime1.fromTo(".resontitle1", {marginLeft:'18vw' },{marginLeft:'0vw' }, 0)
    resontime1.fromTo(".cloudy-foogy", {opacity:1},{opacity:0}, 0)

    let resontime2 = gsap.timeline();
    ScrollTrigger.create({
        animation: resontime2,
        trigger: ".scrollElement",
        start: "1000 top",
        end: "1100 top",
        scrub: 3,
    });
    resontime2.fromTo(".resontitle2", {marginLeft:'-21vw'},{marginLeft:'0vw' }, 0)

    let resontime3 = gsap.timeline();
    ScrollTrigger.create({
        animation: resontime3,
        trigger: ".scrollElement",
        start: "1050 top",
        end: "1200 top",
        scrub: 3,
    });
    resontime3.fromTo(".resontitle3", {marginLeft:'21vw'},{marginLeft:'0vw' }, 0)


    let dragontime = gsap.timeline();
    ScrollTrigger.create({
        animation: dragontime,
        trigger: ".scrollElement",
        start: "350 top",
        end: "400 400",
        scrub: 3,
    });
    dragontime.fromTo(".dragon", { x:100,autoAlpha:0,rotate:10,ease:"none"},{x:0 * speed,autoAlpha:1,rotate:0,ease:"none"}, 0)

    $(window).scroll(function () {

        $('.top-num').html($(window).scrollTop())
    })





    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "1000 top",
        end: "1200 top",
        scrub: 3,
        onEnter:function () {
            gsap.set(".cloudy-foogy", {display:'none'  })
            gsap.set(".bamboo", {display:'block'  })
        },
        onEnterBack:function () {
            gsap.set(".cloudy-foogy", {display:'block'  })
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "2000 top",
        end: "2000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".cloudy-foogy2", {display:'none'  })
            gsap.set(".cloudy-foogy3", {display:'none'  })

        },
        onEnterBack:function () {
            gsap.set(".cloudy-foogy2", {display:'block'  })
            gsap.set(".cloudy-foogy3", {display:'block'  })
        }
    });

    let housetime = gsap.timeline();
    ScrollTrigger.create({
        animation: housetime,
        trigger: ".scrollElement",
        start: "top top",
        end: "2500",
        scrub: 3,

    });
       // housetime.fromTo(".center-build", { top:'220vh'},{top:'-10vh'}, 0)
       // housetime.to(".center-build", {top:'-140vh'},'+=10%')
    housetime.fromTo(".center-build", { top:'200%'},{top:'-12%'}, 0)
    housetime.to(".center-build", {top:'-185%'},'+=10%')

    let maqarea = gsap.timeline();
    ScrollTrigger.create({
        animation: maqarea,
        trigger: ".scrollElement",
        start: "1000 top",
        end: "1200 1200",
        scrub: true,

    });
    maqarea.fromTo(".maq_area", {opacity:0,duration:0.5},{opacity:1 ,duration:0.5}, 0)

    let go1400 = gsap.timeline();
    ScrollTrigger.create({
        animation: go1400,
        trigger: ".scrollElement",
        start: "1500 top",
        end: "2200",
        scrub: true,

    });
    go1400.to(".maq_area", {opacity:0}, 0)

    let bggray1 = gsap.timeline();
    ScrollTrigger.create({
        animation: bggray1,
        trigger: ".scrollElement",
        start: "900 top",
        end: "2500 top",
        scrub: 3,
    });
    bggray1.fromTo(".bg-grar-1", {bottom:'-52vh'},{bottom:'80vh' }, 0)
    bggray1.fromTo(".bg-grar-2", {bottom:'-39vh'},{bottom:'0vh' }, 0)

    let sland1 = gsap.timeline();
    ScrollTrigger.create({
        animation: sland1,
        trigger: ".scrollElement",
        start: "1200 top",
        end: "2800 top",
        scrub: 2,
    });
    sland1.fromTo(".sland-01", {bottom: '-27%'},{bottom:'100%' }, 0)

    let bamboo = gsap.timeline();
    ScrollTrigger.create({
        animation: bamboo,
        trigger: ".scrollElement",
        start: "1600 top",
        end: "2800 top",
        scrub: 2,
    });
    bamboo.fromTo(".bamboo", {bottom: '-110%'},{bottom:'-15%' }, 0)

    let bambooout = gsap.timeline();
    ScrollTrigger.create({
        animation: bambooout,
        trigger: ".scrollElement",
        start: "3000 top",
        end: "3300 top",
        scrub: 2,
    });
    bambooout.to(".bamboo", {left:'-10vw'}, 0)

    let sun1 = gsap.timeline();
    ScrollTrigger.create({
        animation: sun1,
        trigger: ".scrollElement",
        start: "1900 top",
        end: "2500 top",
        scrub: 3,
    });
    sun1.fromTo(".center-red", {scale:1},{scale:2}, 0)
    sun1.fromTo(".center-red", {opacity:1},{opacity:0}, '+=50%')


    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "2200 top",
        end: "2200",
        scrub: 3,
        onEnter:function () {
            gsap.set(".cirmove", {display:'block'  })
        },
        onEnterBack:function () {
            gsap.set(".cirmove", {display:'none'  })
        }
    });
    let cirmove = gsap.timeline();
    ScrollTrigger.create({
        animation: cirmove,
        trigger: ".scrollElement",
        start: "2300 top",
        end: "2700 top",
        scrub: true,
    });
    cirmove.fromTo(".cirmove", {opacity:0},{opacity:1}, 0)

    let cirmove1 = gsap.timeline();
    ScrollTrigger.create({
        animation: cirmove1,
        trigger: ".scrollElement",
        start: "3000 top",
        end: "4500 top",
        scrub: 3,
    });
    cirmove1.to(".cirmove", {marginLeft:'-92vw'}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "2500 top",
        end: "2500",
        scrub: 3,
        onEnter:function () {
            gsap.set(".webtitle-cht", {display:'block'  })
            gsap.set(".h2o1", {display:'block'  })
            gsap.set(".h2s1", {display:'block'  })

        },
        onEnterBack:function () {
            gsap.set(".webtitle-cht", {display:'none'  })
            gsap.set(".h2o1", {display:'none'  })
            gsap.set(".h2s1", {display:'none'  })

        }
    });
    let webtitlemovw = gsap.timeline();
    ScrollTrigger.create({
        animation: webtitlemovw,
        trigger: ".scrollElement",
        start: "3200 top",
        end: "5000 top",
        scrub: 3,
    });
    webtitlemovw.fromTo(".webdesign-title-outline", {left: '0vw'},{left: '-82vw'}, 0)
    webtitlemovw.fromTo(".webdesign-title-solid", {left: '0vw'},{left: '-82vw'}, 0)

    let lion01 = gsap.timeline();
    ScrollTrigger.create({
        animation: lion01,
        trigger: ".scrollElement",
        start: "2800 top",
        end: "5800 top",
        scrub: 3,
    });
    lion01.fromTo(".lion01", {right: '-25vw'},{right: '100vw'}, 0)

    let lionbgmountain = gsap.timeline();
    ScrollTrigger.create({
        animation: lionbgmountain,
        trigger: ".scrollElement",
        start: "3000 top",
        end: "8500 top",
        scrub: 3,
    });
    lionbgmountain.fromTo(".lionbgmountain", {right: '-44vw'},{right: '99vw'}, 0)
    lionbgmountain.to(".bg-grar-2", {left: '-46vw'}, 0)
    lionbgmountain.to(".bg-grar-1", {marginBottom:'20vh'}, 0)


    let web01 = gsap.timeline();
    ScrollTrigger.create({
        animation: web01,
        trigger: ".scrollElement",
        start: "3000 top",
        end: "10000 top",
        scrub: 3,
    });
    web01.fromTo(".webox-1", {left: '100vw'},{left: '-100vw'}, 0)

    let web01item = gsap.timeline();
    ScrollTrigger.create({
        animation: web01item,
        trigger: ".scrollElement",
        start: "4000 top",
        end: "8000 top",
        scrub: 3,
    });
    web01item.fromTo(".web1title", {left: '10vw'},{left: '-5vw'}, 0)
    web01item.fromTo(".web1titleo", {left: '10vw'},{left: '-5vw'}, 0)
    web01item.fromTo(".web1-num", {left: '15vw'},{left: '11vw'}, 0)
    web01item.fromTo(".web1-txtbox", {right: '5vw'},{right: '15vw'}, 0)


    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "3800 top",
        end: "3800",
        scrub: 3,
        onEnter:function () {
            gsap.set(".center-reds", {display:'block',duration: 0.5,transform:'translate(0px,0)', opacity: 1})
            gsap.set(".title-h2", {display:'inline-block'})
            gsap.set(".web1-num", {display:'block'})
            gsap.to(".center-red", {display:'none'})
        },
        onEnterBack:function () {
            gsap.set(".center-reds", {display:'block',duration:  0.5,transform:'translate(0px,0)', opacity: 1})
            gsap.to(".center-reds", {display:'none',duration: 0.5,transform:'translate(0px,50px)', opacity: 0})
            gsap.set(".center-red", {display:'block'})

        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "4800 top",
        end: "4800",
        scrub: 3,
        onEnter:function () {
            gsap.set(".web1-txtbox", {display:'block'})
        }
    });

    let web02 = gsap.timeline();
    ScrollTrigger.create({
        animation: web02,
        trigger: ".scrollElement",
        start: "5000 top",
        end: "17000 top",
        scrub: 3,
    });
    web02.fromTo(".webox-2and3", {left: '100vw'},{left: '-120vw'}, 0)
    web02.fromTo(".webox-2and3-bg", {left: '100vw'},{left: '-120vw'}, 0)

    let web02item = gsap.timeline();
    ScrollTrigger.create({
        animation: web02item,
        trigger: ".scrollElement",
        start: "5000 top",
        end: "8200 top",
        scrub: 2,
    });
    web02item.fromTo(".web2title", {left: '5vw'},{left: '-8vw'}, 0)
    web02item.fromTo(".web2titleo", {left: '5vw'},{left: '-8vw'}, 0)
    web02item.fromTo(".web2-num", {left: '5vw'},{left: '-7vw'}, 0)
    web01item.fromTo(".web2-txtbox", {left: '25vw'},{left: '18vw'}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "5100 top",
        end: "5100",
        scrub: 3,
        onEnter:function () {
            gsap.set(".web2title .title2-h2", {display:'inline-block'})
            gsap.set(".web2titleo .title2-h2", {display:'inline-block'})
            gsap.set(".web2-num", {display:'block'})

        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "5800 top",
        end: "5800",
        scrub: 3,
        onEnter:function () {
            gsap.set(".web2-txtbox", {display:'block'})
        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "7000 top",
        end: "7000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".title3-h2", {display:'inline-block'})
            gsap.set(".web3-num", {display:'block'})
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "7400 top",
        end: "7400",
        scrub: 3,
        onEnter:function () {
            gsap.set(".web3-txtbox", {display:'block'})
        }
    });

    let web03item = gsap.timeline();
    ScrollTrigger.create({
        animation: web03item,
        trigger: ".scrollElement",
        start: "6700 top",
        end: "9000 top",
        scrub: 2,
    });
    web03item.fromTo(".web3title", {left: '60vw'},{left: '52vw'}, 0)
    web03item.fromTo(".web3titleo", {left: '60vw'},{left: '52vw'}, 0)
    web03item.fromTo(".web3-num", {right: '15vw'},{right: '20vw'}, 0)
    web03item.fromTo(".web3-txtbox", {right: '-15vw'},{right: '-3vw'}, 0)
    web03item.fromTo(".img03", {right: '-15vw'},{right: '-8vw'}, 0)


    // ScrollTrigger.create({
    //     trigger: ".scrollElement",
    //     start: "4400 top",
    //     end: "4400",
    //     scrub: 1,
    //     preventOverlaps: true,
    //     fastScrollEnd: true,
    //     onEnter:function () {
    //         gsap.set(".img01", {filter: 'grayscale(0%)',duration:  0.5})
    //     },
    //     onEnterBack:function () {
    //         gsap.set(".img01", {filter: 'grayscale(100%)',duration:  0.5})
    //     }
    // });
    // ScrollTrigger.create({
    //     trigger: ".scrollElement",
    //     start: "6200 top",
    //     end: "6200",
    //     scrub: 1,
    //     preventOverlaps: true,
    //     fastScrollEnd: true,
    //     onEnter:function () {
    //         gsap.set(".img01", {filter: 'grayscale(100%)',duration:  0.5})
    //     },
    //     onEnterBack:function () {
    //         gsap.set(".img01", {filter: 'grayscale(0%)',duration:  0.5})
    //     }
    // });

    let redsmove2 = gsap.timeline();
    ScrollTrigger.create({
        animation: redsmove2,
        trigger: ".scrollElement",
        start: "5200 top",
        end: "7500 top",
        preventOverlaps: true,
        fastScrollEnd: true,
        scrub: 1,
    });
    redsmove2.fromTo(".center-reds", {marginTop:'5vw'},{marginTop:'-4vw'}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "7800 top",
        end: "7800",
        preventOverlaps: true,
        fastScrollEnd: true,
        scrub: 1,
        onEnter:function () {
            gsap.set(".center-reds", {display:'none'})
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "7100 top",
        end: "7100",
        preventOverlaps: true,
        fastScrollEnd: true,
        scrub: 1,
        onEnterBack:function () {
            gsap.set(".center-reds", {display:'block'})
        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "7000 top",
        end: "7000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".webox-4", {display:'block'})
        },

    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "6500 top",
        end: "6500",
        scrub: 3,

        onEnterBack:function () {
            gsap.set(".webox-4", {display:'none'})
        }
    });

    let w3redsun = gsap.timeline();
    ScrollTrigger.create({
        animation: w3redsun,
        trigger: ".scrollElement",
        start: "7200 top",
        end: "7800 top",

        scrub: 2,

    });
    w3redsun.fromTo(".red-sun", {left: '25vw'},{left: '45vw'}, 0)



    let web04 = gsap.timeline();
    ScrollTrigger.create({
        animation: web04,
        trigger: ".scrollElement",
        start: "7000 top",
        end: "17000 top",
        scrub: 3,

    });
    web04.fromTo(".webox-4", {ease: "none",left: '100vw'},{left: '-110vw',ease: "none"}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "10000 top",
        end: "10000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".web4-title", {display:'block'})        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "11000 top",
        end: "11000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".w4iconbox", {display:'block'})
            gsap.set(".linetobox", {display:'block'})
        },
        onEnterBack:function () {
        }
    });
    let web05 = gsap.timeline();
    ScrollTrigger.create({
        animation: web05,
        trigger: ".scrollElement",
        start: "13000 top",
        end: "21000 top",
        scrub: 3,

    });
    web05.fromTo(".webox-5", {ease: "none",left: '100vw'},{left: '-105vw',ease: "none"}, 0)

    let web05item = gsap.timeline();
    ScrollTrigger.create({
        animation: web05item,
        trigger: ".scrollElement",
        start: "13000 top",
        end: "18000 top",
        scrub: 3,
    });
    web05item.fromTo(".work-mainthree ul", {left: '30vw'},{left: '0vw'}, 0)
    web05item.fromTo(".islandbox-1 .item01", {left: '20vw'},{left: '-5vw'}, 0)
    web05item.fromTo(".islandbox-1 .item02", {right: '-25vw'},{right: '5vw'}, 0)
    web05item.fromTo(".web5bggray-1", {left: '70vw'},{left: '50vw'}, 0)


    let web05item1 = gsap.timeline();
    ScrollTrigger.create({
        animation: web05item1,
        trigger: ".scrollElement",
        start: "16000 top",
        end: "20000 top",
        scrub: 3,
    });
    web05item1.fromTo(".web5bggray-1", {left: '70vw'},{left: '40vw'}, 0)
    web05item1.fromTo(".w5mountain1", {left: '100vw'},{left: '62vw'}, 0)
    web05item1.fromTo(".w5mountain2", {left: '80vw'},{left: '105vw'}, 0)

    let web5bggray2 = gsap.timeline();
    ScrollTrigger.create({
        animation: web5bggray2,
        trigger: ".scrollElement",
        start: "20000 top",
        end: "24000 top",
        scrub: 3,
    });
    web5bggray2.fromTo(".web5bggray-2", {bottom: '-42vw',autoAlpha:0},   {bottom: '15vw',autoAlpha:1},       0)


    let web05itemgo = gsap.timeline();
    ScrollTrigger.create({
        animation: web05itemgo,
        trigger: ".scrollElement",
        start: "22000 top",
        end: "24000 top",
        scrub: 3,
    });
    web05itemgo.to(".work-mainthree", {top: '-33vh'},       0)
    web05itemgo.to(".w5mountain2", {bottom: '12vh',autoAlpha:0},       0)
    web05itemgo.to(".treeland", {top: '-100vh'},       0)

    let w5redsun = gsap.timeline();
    ScrollTrigger.create({
        animation: w5redsun,
        trigger: ".scrollElement",
        start: "14200 top",
        end: "17500 top",
        scrub: 1,
    });
    w5redsun.fromTo(".w5redsun", {ease: "none",transform:'translate(0px,0px)',duration:0.5},{transform:'translate(2vw, -16vw)',ease: "none",duration:0.5}, 0)
    w5redsun.to(".w5redsun", {transform:'translate(4vw, -22vw)',ease: "none",duration:0.5}, ">")
    w5redsun.to(".w5redsun", {transform:'translate(14vw, -24.5vw)',ease: "none",duration:0.5}, ">")
    w5redsun.to(".w5redsun", {transform:'translate(34vw, -26vw)',ease: "none",duration:0.5}, ">")

    let logoline = gsap.timeline();
    ScrollTrigger.create({
        animation: logoline,
        trigger: ".scrollElement",
        start: "14900 top",
        end: "16000 top",
        scrub: 1,
    });
    logoline.fromTo(".logoline .ovh", {height:'45%',duration:0.3},{height:'100%',duration:0.3}, 0)


    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "13500 top",
        end: "13500",
        scrub: 3,
        onEnter:function () {
            gsap.set(".web5title", {display:'block'})
        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "15500 top",
        end: "15500",
        scrub: 3,
        onEnter:function () {
            gsap.set(".web5slogna", {display:'block'})
            gsap.set(".center-reds", {display:'none'})
        }
    });



    let phone = gsap.timeline();
    ScrollTrigger.create({
        animation: phone,
        trigger: ".scrollElement",
        start: "25000 top",
        end: "27000 top",
        scrub: 3,
    });
    phone.fromTo(".phone-box", {top:'-1vw'},{top:'-5.5vw'}, 0)


    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "23000 top",
        end: "23000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".app-title", {display:'block'})
            gsap.set(".app-title2", {display:'block'})
        }
    });

    let apptitle1 = gsap.timeline();
    ScrollTrigger.create({
        animation: apptitle1,
        trigger: ".scrollElement",
        start: "22000 top",
        end: "26000 top",
        scrub: 3,
    });
    apptitle1.fromTo(".app-title", {top:'135%'},{top:'-50%'}, 0)

    let apptitle2 = gsap.timeline();
    ScrollTrigger.create({
        animation: apptitle2,
        trigger: ".scrollElement",
        start: "22000 top",
        end: "27000 top",
        scrub: 3,
    });
    apptitle2.fromTo(".app-title2", {bottom:'-5vw'},{bottom:'70vw'}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "20000 top",
        end: "20000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".appred-sun", {display:'block'})
        },
        onEnterBack:function () {
            gsap.set(".appred-sun", {display:'none'})
        }
    });

    let appredsun = gsap.timeline();
    ScrollTrigger.create({
        animation: appredsun,
        trigger: ".scrollElement",
        start: "22000 top",
        end: "25000 top",
        scrub: 3,
    });
    appredsun.to(".appred-sun", {top:'-63vw'}, 0)


    let islind3 = gsap.timeline();
    ScrollTrigger.create({
        animation: islind3,
        trigger: ".scrollElement",
        start: "22800 top",
        end: "29000 top",
        scrub: 3,
    });
    islind3.fromTo(".islind3", {bottom:'-35vw'},{bottom:'65vw'}, 0)


    let islindad = gsap.timeline();
    ScrollTrigger.create({
        animation: islindad,
        trigger: ".scrollElement",
        start: "23500 top",
        end: "30000 top",
        scrub: 3,
    });
    islindad.fromTo(".islindad", {bottom:'-15vw'},{bottom:'65vw'}, 0)

    let islindapple = gsap.timeline();
    ScrollTrigger.create({
        animation: islindapple,
        trigger: ".scrollElement",
        start: "24000 top",
        end: "31000 top",
        scrub: 3,
    });
    islindapple.fromTo(".islindapple", {bottom:'-10vw'},{bottom:'66vw'}, 0)


    let appboxgray = gsap.timeline();
    ScrollTrigger.create({
        animation: appboxgray,
        trigger: ".scrollElement",
        start: "23000 top",
        end: "25000 top",
        scrub: 3,
    });
    appboxgray.fromTo(".appboxgray", {bottom:'-35vw',autoAlpha:0},{bottom:'0vw',autoAlpha:1}, 0)



    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "24000 top",
        end: "24000",
        scrub:1,
        onEnter:function () {
            gsap.set(".iconbubble1", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".iconbubble1", {autoAlpha:1,duration:0.3,scale:1})
            gsap.set(".line-porterstar", {autoAlpha:0})
            gsap.to(".webox-5", {zIndex:6})
        },
        onEnterBack:function () {
            gsap.to(".iconbubble1", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".webox-5", {zIndex:8})
        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "24700 top",
        end: "24700",
        scrub:1,
        onEnter:function () {
            gsap.set(".iconbubble2", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".iconbubble2", {autoAlpha:1,duration:0.3,scale:1})

        },
        onEnterBack:function () {
            gsap.to(".iconbubble2", {autoAlpha:0,duration:0.3,scale:0.5})
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "25400 top",
        end: "25400",
        scrub:1,
        onEnter:function () {
            gsap.set(".iconbubble3", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".iconbubble3", {autoAlpha:1,duration:0.3,scale:1})

        },
        onEnterBack:function () {
            gsap.to(".iconbubble3", {autoAlpha:0,duration:0.3,scale:0.5})
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "26100 top",
        end: "26100",
        scrub:1,
        onEnter:function () {
            gsap.set(".iconbubble4", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".iconbubble4", {autoAlpha:1,duration:0.3,scale:1})

        },
        onEnterBack:function () {
            gsap.to(".iconbubble4", {autoAlpha:0,duration:0.3,scale:0.5})
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "28600 top",
        end: "28600",
        scrub:1,
        onEnter:function () {
            gsap.set(".iconbubble5", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".iconbubble5", {autoAlpha:1,duration:0.3,scale:1})
            gsap.set(".appbox", {zIndex:6})
            gsap.to(".appbox", {zIndex:10})
        },
        onEnterBack:function () {
            gsap.to(".iconbubble5", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".appbox", {zIndex:6})
        }
    });

    let appiconpop1 = gsap.timeline();
    ScrollTrigger.create({
        animation: appiconpop1,
        trigger: ".scrollElement",
        start: "24000 top",
        end: "26000 top",
        scrub: 3,
    });
    appiconpop1.fromTo(".iconbubble1", {bottom:'32w'},{bottom:'-2vw'}, 0)

    let appiconpop2 = gsap.timeline();
    ScrollTrigger.create({
        animation: appiconpop2,
        trigger: ".scrollElement",
        start: "24600 top",
        end: "27000 top",
        scrub: 3,
    });
    appiconpop2.fromTo(".iconbubble2", {bottom:'32w'},{bottom:'-2vw'}, 0)

    let appiconpop3 = gsap.timeline();
    ScrollTrigger.create({
        animation: appiconpop3,
        trigger: ".scrollElement",
        start: "25300 top",
        end: "28000 top",
        scrub: 3,
    });
    appiconpop3.fromTo(".iconbubble3", {bottom:'30w'},{bottom:'-2vw'}, 0)

    let appiconpop4 = gsap.timeline();
    ScrollTrigger.create({
        animation: appiconpop4,
        trigger: ".scrollElement",
        start: "26000 top",
        end: "29000 top",
        scrub: 3,
    });
    appiconpop4.fromTo(".iconbubble4", {bottom:'30w'},{bottom:'-2vw'}, 0)

    let appiconpop5 = gsap.timeline();
    ScrollTrigger.create({
        animation: appiconpop5,
        trigger: ".scrollElement",
        start: "28500 top",
        end: "31000 top",
        scrub: 3,
    });
    appiconpop5.fromTo(".iconbubble5", {bottom:'23w'},{bottom:'-2vw'}, 0)


    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "26000 top",
        end: "26000",
        scrub:1,
        onEnter:function () {
            gsap.set(".appicon1 .iconbox", {autoAlpha:0,scale:0.5})
            gsap.to(".appicon1 .iconbox", {keyframes: [{autoAlpha:0,scale:0.5, duration:0}, {autoAlpha:1,scale:1.2, duration:0.2},{scale:1, duration:0.2}]})
            gsap.set(".appicon1 p", {autoAlpha:0})
            gsap.to(".appicon1 p", {autoAlpha:1, duration:0.5,delay:0.5})

        },
        onEnterBack:function () {
            gsap.to(".appicon1 .iconbox", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".appicon1 p", {autoAlpha:0, duration:0})
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "26700 top",
        end: "26700",
        scrub:1,
        onEnter:function () {
            gsap.set(".appicon2 .iconbox", {autoAlpha:0,scale:0.5})
            gsap.to(".appicon2 .iconbox", {keyframes: [{autoAlpha:0,scale:0.5, duration:0}, {autoAlpha:1,scale:1.2, duration:0.2},{scale:1, duration:0.2}]})
            gsap.set(".appicon2 p", {autoAlpha:0})
            gsap.to(".appicon2 p", {autoAlpha:1, duration:0.5,delay:0.5})

        },
        onEnterBack:function () {
            gsap.to(".appicon2 .iconbox", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".appicon2 p", {autoAlpha:0, duration:0})

        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "27500 top",
        end: "27500",
        scrub:1,
        onEnter:function () {
            gsap.set(".appicon3 .iconbox", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".appicon3 .iconbox", {keyframes: [{autoAlpha:0,scale:0.5, duration:0}, {autoAlpha:1,scale:1.2, duration:0.2},{scale:1, duration:0.2}]})
            gsap.set(".appicon3 p", {autoAlpha:0})
            gsap.to(".appicon3 p", {autoAlpha:1, duration:0.5,delay:0.5})

        },
        onEnterBack:function () {
            gsap.to(".appicon3 .iconbox", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".appicon3 p", {autoAlpha:0, duration:0})

        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "28500 top",
        end: "28500",
        scrub:1,
        onEnter:function () {
            gsap.set(".appicon4 .iconbox", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".appicon4 .iconbox", {keyframes: [{autoAlpha:0,scale:0.5, duration:0}, {autoAlpha:1,scale:1.2, duration:0.2},{scale:1, duration:0.2}]})
            gsap.set(".appicon4 p", {autoAlpha:0})
            gsap.to(".appicon4 p", {autoAlpha:1, duration:0.5,delay:0.5})

        },
        onEnterBack:function () {
            gsap.to(".appicon4 .iconbox", {autoAlpha:0,duration:0.3,scale:0.5})
            gsap.to(".appicon4 p", {autoAlpha:0, duration:0})

        }
    });

    let iconlinkto = gsap.timeline();
    ScrollTrigger.create({
        animation: iconlinkto,
        trigger: ".scrollElement",
        start: "28500 top",
        end: "29000 top",
        scrub: 3,
    });
    iconlinkto.fromTo(".iconcontact", {bottom:'-2vw',autoAlpha:0},{bottom:'0vw',autoAlpha:1}, 0)


    let porterstar = gsap.timeline();
    ScrollTrigger.create({
        animation: porterstar,
        trigger: ".scrollElement",
        start: "30000 top",
        end: "31000 top",
        scrub: 1,
    });
    porterstar.fromTo(".line-porterstar", {autoAlpha:0},{autoAlpha:1}, 0)
    porterstar.fromTo(".icon-contbox", {autoAlpha:1},{autoAlpha:0}, ">-=150%")

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "31000 top",
        end: "31000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".porterstar-titlebox", {display:'block',autoAlpha:1})
        },
        onEnterBack:function () {
            gsap.to(".porterstar-titlebox", {autoAlpha:0,duration:0.3,display:'none'})

        }
    });

    let portertitle = gsap.timeline();
    ScrollTrigger.create({
        animation: portertitle,
        trigger: ".scrollElement",
        start: "31000 top",
        end: "34500 top",
        scrub: 3,
    });
    portertitle.fromTo(".porterstar-titlebox", {top:'50vw'},{top:'-10vw'}, 0)

    let protostarlogo = gsap.timeline();
    ScrollTrigger.create({
        animation: protostarlogo,
        trigger: ".scrollElement",
        start: "30000 top",
        end: "35000 top",
        scrub: 3,
    });
    protostarlogo.fromTo(".protostarlogo", {top:'50vw'},{top:'-18vw'}, 0)
    protostarlogo.to(".webdesign-title-outline", {marginLeft:'-18vw'}, 0)


    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "32000 top",
        end: "32000",
        scrub: 3,
        onEnter:function () {
            gsap.to(".yen", {display:'block'})

        },
        onEnterBack:function () {
            gsap.to(".yen", {autoAlpha:0,duration:0.3,display:'none'})

        }
    });



    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "34000 top",
        end: "34000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".line-porterstar", {autoAlpha:1})
            gsap.to(".line-porterstar", {autoAlpha:0,duration:0.3})
            gsap.to(".fishman", {display:'block'})

        },
        onEnterBack:function () {
            gsap.to(".line-porterstar", {autoAlpha:1,duration:0.3})
        }
    });


    let graymove = gsap.timeline();
    ScrollTrigger.create({
        animation: graymove,
        trigger: ".scrollElement",
        start: "32000 top",
        end: "40500 top",
        scrub: 2,
    });
    graymove.fromTo(".appboxgray", {autoAlpha:1},{marginBottom:'-30vw',autoAlpha:0}, 0)
    graymove.to(".web5bggray-2", {marginBottom:'-70vw',autoAlpha:0}, 0)


    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "39000 top",
        end: "39000",
        scrub: 1,
        onEnter:function () {
            gsap.to(".appboxgray", {autoAlpha:0,duration:0.3,display:'none'})
            gsap.to(".web5bggray-2", {autoAlpha:0,duration:0.3,display:'none'})
        },
        onEnterBack:function () {
            gsap.to(".appboxgray", {display:'block',duration:0.3})
            gsap.to(".web5bggray-2", {display:'block',duration:0.3})

        }
    });


    let lineqa1 = gsap.timeline();
    ScrollTrigger.create({
        animation: lineqa1,
        trigger: ".scrollElement",
        start: "34500 top",
        end: "37500 top",
        scrub: 3,
    });
    lineqa1.fromTo(".lineqa1", {autoAlpha:0,display:'none',duration:0.3,y:20},{y:0,autoAlpha:1,display:'flex',duration:0.3}, 0)
    lineqa1.fromTo(".lineqa2", {autoAlpha:0,display:'none',duration:0.3,y:20},{y:0,autoAlpha:1,display:'inline-block',duration:0.3}, "<1")
    lineqa1.fromTo(".lineqa3", {autoAlpha:0,display:'none',duration:0.3,y:20},{y:0,autoAlpha:1,display:'inline-block',duration:0.3}, "<1")
    lineqa1.fromTo(".lineqa4", {autoAlpha:0,display:'none',duration:0.3,y:20},{y:0,autoAlpha:1,display:'flex',duration:0.3}, "<1")
    lineqa1.fromTo(".lineqa5", {autoAlpha:0,display:'none',duration:0.3,y:20},{y:0,autoAlpha:1,display:'block',duration:0.3}, "<1")
    lineqa1.fromTo(".lineqa6", {autoAlpha:0,display:'none',duration:0.3,y:20},{y:0,autoAlpha:1,display:'flex',duration:0.3}, "<1")
    lineqa1.fromTo(".lineqa7", {autoAlpha:0,display:'none',duration:0.3,y:20},{y:0,autoAlpha:1,display:'block',duration:0.3}, "<1")


    let leftfall = gsap.timeline();
    ScrollTrigger.create({
        animation: leftfall,
        trigger: ".scrollElement",
        start: "34500 top",
        end: "44500 top",
        scrub: 1,
    });
    leftfall.to(".left-waterfall", {bottom:'8vw'}, 0)
    leftfall.to(".left-waterfall", {bottom:'35vw'}, ">")

    let appboxh = gsap.getProperty(".appbox", "height");

    let appboxmove = gsap.timeline();
    ScrollTrigger.create({
        animation: appboxmove,
        trigger: ".scrollElement",
        start: "38000 top",
        end: "43000 top",
        scrub: 3,
    });
    appboxmove.to(".appbox", {top:-appboxh}, 0)


    let rightfall = gsap.timeline();
    ScrollTrigger.create({
        animation: rightfall,
        trigger: ".scrollElement",
        start: "35500 top",
        end: "44500 top",
        scrub: 1,
    });
    rightfall.to(".right-waterfall", {bottom:'8vw'}, 0)
    rightfall.to(".right-waterfall", {bottom:'35vw'}, ">")


    let appbuild = gsap.timeline();
    ScrollTrigger.create({
        animation: appbuild,
        trigger: ".scrollElement",
        start: "22000 top",
        end: "27000 top",
        scrub: 3,
    });
    appbuild.fromTo(".center-build2", {bottom:'-65vw'},{bottom:'17vw'}, 0)


    let appbuild2 = gsap.timeline();
    ScrollTrigger.create({
        animation: appbuild2,
        trigger: ".scrollElement",
        start: "29500 top",
        end: "35000 top",
        scrub: 1,
    });
    // appbuild2.to(".center-build2", {bottom:'71vw'}, 0)
    appbuild2.to(".center-build2", {marginBottom:'54vw'}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "38000 top",
        end: "38000",
        scrub: 1,
        onEnter:function () {
            gsap.to(".client", {autoAlpha:1})
        },
        onEnterBack:function () {
            gsap.to(".client", {autoAlpha:0})
        }
    });
    let appbuild3 = gsap.timeline();
    ScrollTrigger.create({
        animation: appbuild3,
        trigger: ".scrollElement",
        start: "38000 top",
        end: "45000 top",
        scrub: 1,
    });
    // appbuild3.to(".center-build2", {bottom:'150vw'}, 0)
    appbuild3.to(".center-build2", {transform:"translateY(-70vw)"}, 0)


    let ccheight = gsap.getProperty(".client", "height");

    let client = gsap.timeline();
    ScrollTrigger.create({
        animation: client,
        trigger: ".scrollElement",
        start: "38600 top",
        end: "49500 top",
        scrub: 3,
    });
    client.fromTo(".client", {bottom:-ccheight},{bottom:ccheight}, 0)



    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "41000 top",
        end: "41000",
        scrub: 1,
        onEnter:function () {
            gsap.set(".client-tittlepool .title2-h2", {display:'inline-block'})
            gsap.set(".title-chtft", {display:'inline-block'})
            gsap.to(".appbox", {zIndex:6})
            gsap.to(".yen", {autoAlpha:0,duration:0.3,display:'none'})
        },
        onEnterBack:function () {
            gsap.to(".appbox", {zIndex:10})
        }
    });
    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "42000 top",
        end: "42000",
        scrub: 1,
        onEnter:function () {
            gsap.to(".appbox", {zIndex:6})
            gsap.to(".cbggray-1", {display:'block'})
        },
        onEnterBack:function () {
            gsap.to(".appbox", {zIndex:10})
        }
    });
    let contact = gsap.timeline();
    ScrollTrigger.create({
        animation: contact,
        trigger: ".scrollElement",
        start: "42000 top",
        end: "46000 top",
        scrub: 3,
    });
    contact.fromTo(".contact-area", {bottom:'-52vw'},{bottom:'0vw'}, 0)
    contact.fromTo(".cbggray-1", {autoAlpha:0},{autoAlpha:1}, 0)

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "43000 top",
        end: "43000",
        scrub: 1,
        onEnter:function () {
            gsap.set(".contact-title .title2-h2", {display:'inline-block'})
            gsap.set(".title-chtcc", {display:'inline-block'})
        }
    });

    ScrollTrigger.create({
        trigger: ".scrollElement",
        start: "43000 top",
        end: "43000",
        scrub: 3,
        onEnter:function () {
            gsap.set(".clogobox", {display:'flex',autoAlpha:1})
            gsap.set(".rarea", { display:'block',autoAlpha:1,duration:0.3})
        },
        onEnterBack:function () {
            gsap.to(".clogobox", {autoAlpha:0,duration:0.3,display:'none'})
            gsap.set(".rarea", { display:'none',autoAlpha:0,duration:0.3})

        }
    });

    let linkcirmove = gsap.timeline();
    ScrollTrigger.create({
        animation: linkcirmove,
        trigger: ".scrollElement",
        start: "43500 top",
        end: "44000 top",
        scrub: 1,
    });
    linkcirmove.fromTo(".leftcir", {rotate:'45deg',marginLeft:'-7.5vw',autoAlpha:0},{rotate:'0deg',marginLeft:'-27vw',autoAlpha:1}, 0)
    linkcirmove.fromTo(".rightcir", {rotate:'-45deg',marginRight:'-7.5vw',autoAlpha:0},{rotate:'0deg',marginRight:'-27vw',autoAlpha:1}, 0)

    let lion = gsap.timeline();
    ScrollTrigger.create({
        animation: lion,
        trigger: ".scrollElement",
        start: "43500 top",
        end: "45000 top",
        scrub: 1,
    });
    lion.fromTo(".lion-left", {left: '-22vw',autoAlpha:0},{left:'-3.125vw',autoAlpha:1}, 0)
    lion.fromTo(".lion-right", {right: '-22vw',autoAlpha:0},{right:'-3.125vw',autoAlpha:1}, 0)

})
ScrollTrigger.matchMedia({
    "(min-width: 1280px)": function() {

    },
    "(max-width:1024px)": function() {
        let mbmou1 = gsap.timeline();
        ScrollTrigger.create({
            animation: mbmou1,
            trigger: ".index-mball",
            start: "0 top",
            end: "200 top",
            scrub: 3,
        });
        mbmou1.fromTo(".monr1m", {marginTop: '0vw'},{marginTop:'-6vw'}, 0)

        let mbmou = gsap.timeline();
        ScrollTrigger.create({
            animation: mbmou,
            trigger: ".index-mball",
            start: "80 top",
            end: "350 top",
            scrub: 3,
        });
        mbmou.fromTo(".mon-lm1", {bottom: '-5vw'},{bottom:'8vw'}, 0)
        mbmou.fromTo(".mon-lm2", {bottom: '-5vw'},{bottom:'5vw'}, 0)
        mbmou.fromTo(".mon-rm1", {bottom: '-10vw'},{bottom:'5vw'}, 0)
        mbmou.fromTo(".mon-rm2", {bottom: '-5vw'},{bottom:'5vw'}, 0)
        mbmou.fromTo(".monr1m", {marginTop: '0vw'},{marginTop:'-3vw'}, 0)

        let circlipm = gsap.timeline();
        ScrollTrigger.create({
            animation: circlipm,
            trigger: ".index-mball",
            start: "900 top",
            end: "1200 top",
            scrub: 3,
        });
        circlipm.fromTo(".cirin", {top: '0vw'},{top:'5vw'}, 0)

        ScrollTrigger.create({
            trigger: ".mb-section2-why",
            start: "-90% top",
            onEnter:function () {
                $('.mb-section2-why').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "-80% top",
            onEnter:function () {
                $('.mb-section3-web').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "-100 top",
            onEnter:function () {
                $('.floattop1').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "100 top",
            onEnter:function () {
                $('.floattop2').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section3-web",
            start: "200 top",
            onEnter:function () {
                $('.floattop3').addClass('vivi')
            }
        });

        let mbdranbg = gsap.timeline();
        ScrollTrigger.create({
            animation: mbdranbg,
            trigger: ".mb-section4-one",
            start: "-500 top",
            end: "350 top",
            scrub: 3,
        });
        mbdranbg.fromTo(".imgaream", {top: '-10vw'},{top:'0vw'}, 0)

        ScrollTrigger.create({
            trigger: ".mb-section4-one",
            start: "-80% top",
            onEnter:function () {
                $('.mb-section4-one').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section5-work",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section5-work').addClass('vivi')
            }
        });

        ScrollTrigger.create({
            trigger: ".mb-section6-app",
            start: "-200 top",
            onEnter:function () {
                $('.mb-section6-app').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".app-content",
            start: "-200 top",
            onEnter:function () {
                $('.app-content').addClass('vivi')
            }
        });

        let section6m = gsap.timeline();
        ScrollTrigger.create({
            animation: section6m,
            trigger: ".mb-section6-app",
            start: "-600 top",
            end: "400 top",
            scrub: 3,
        });
        section6m.fromTo(".mb-section6-app .sun-bg", {top: '15vw'},{top:'0vw'}, 0)
        section6m.fromTo(".mb-section6-app .app-build", {top: '12vw'},{top:25}, 0)
        section6m.fromTo(".mb-section6-app .bg", {bottom: '20vw'},{bottom:'6vw'}, 0)

        ScrollTrigger.create({
            trigger: ".mb-section7-line",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section7-line').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section8-client",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section8-client').addClass('vivi')
            }
        });
        ScrollTrigger.create({
            trigger: ".mb-section9-contact",
            start: "-300 top",
            onEnter:function () {
                $('.mb-section9-contact').addClass('vivi')
            }
        });
    }
});

